/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customerWalletCardTopup } from '../../axios/customerWalletCardTopup'
import type {
	CustomerWalletCardTopupError,
	CustomerWalletCardTopupPathParams,
	CustomerWalletCardTopupRequest,
	CustomerWalletCardTopupResponse,
} from '../../types/CustomerWalletCardTopup'

export const customerWalletCardTopupMutationKey = () => [{ url: '/:organisation/wallet/topup' }] as const

export type CustomerWalletCardTopupMutationKey = ReturnType<typeof customerWalletCardTopupMutationKey>

export type CustomerWalletCardTopupVariables = {
	organisation: CustomerWalletCardTopupPathParams['organisation']
	data: CustomerWalletCardTopupRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::cardTopup */
export function useCustomerWalletCardTopup<TContext = unknown>(
	options?: UseMutationOptions<
		CustomerWalletCardTopupResponse,
		AxiosError<CustomerWalletCardTopupError>,
		CustomerWalletCardTopupVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: customerWalletCardTopupMutationKey(),
		mutationFn: ({ organisation, data }: CustomerWalletCardTopupVariables) =>
			customerWalletCardTopup(organisation, data, config).then(res => res.data),
		...options,
	})
}
